/** Icons are imported separatly to reduce build time */

import { WalletIcon } from '@heroicons/react/24/outline';
import CalendarDaysIcon from '@heroicons/react/24/outline/CalendarDaysIcon';
import Squares2X2Icon from '@heroicons/react/24/outline/Squares2X2Icon';

const iconClasses = `h-6 w-6`;

const routesAdmin = [
  {
    path: '/',
    icon: <Squares2X2Icon className={iconClasses} />,
    name: 'Inicio',
  },

  {
    path: '/historico', // url
    icon: <CalendarDaysIcon className={iconClasses} />, // icon component
    name: 'Histórico de consultas', // name that appear in Sidebar
  },
  {
    path: '/lista-pacientes', // url
    icon: <CalendarDaysIcon className={iconClasses} />, // icon component
    name: 'Lista Pacientes', // name that appear in Sidebar
  },
  {
    path: '/lista-especialistas', // url
    icon: <CalendarDaysIcon className={iconClasses} />, // icon component
    name: 'Lista Especialistas', // name that appear in Sidebar
  },
  {
    path: '/agendamentos', // url
    icon: <CalendarDaysIcon className={iconClasses} />, // icon component
    name: 'Agendamentos Pacientes', // name that appear in Sidebar
  },
  {
    path: '/agendamentos-especialistas', // url
    icon: <CalendarDaysIcon className={iconClasses} />, // icon component
    name: 'Agendamentos Especialistas', // name that appear in Sidebar
  },
  {
    path: '/lista-testes', // url
    icon: <WalletIcon className={iconClasses} />, // icon component
    name: 'Testes realizados', // name that appear in Sidebar
  },
  // {
  //   path: '/consultas/admin', // url
  //   icon: <CalendarDaysIcon className={iconClasses} />, // icon component
  //   name: 'Todas Consultas', // name that appear in Sidebar
  // },
  // {
  //   path: '/conteudo/admin', // url
  //   icon: <CalendarDaysIcon className={iconClasses} />, // icon component
  //   name: 'Gerencie Conteudos', // name that appear in Sidebar
  // },
  // {
  //   path: '/pagamentos/admin', // url
  //   icon: <CalendarDaysIcon className={iconClasses} />, // icon component
  //   name: 'Transações', // name that appear in Sidebar
  // },

  // {
  //   path: '/pagamento/admin', // url
  //   icon: <CreditCardIcon className={`${iconClasses} inline`} />, // icon component
  //   name: 'Pagamentos Admin', // name that appear in Sidebar
  //   submenu: [
  //     {
  //       path: '/pagamento/admin', // url
  //       icon: <CurrencyDollarIcon className={submenuIconClasses} />, // icon component
  //       name: 'Comprar Créditos', // name that appear in Sidebar
  //     },
  //     {
  //       path: '/historico/admin', // url
  //       icon: <WalletIcon className={submenuIconClasses} />, // icon component
  //       name: 'Histórico Pagamentos', // name that appear in Sidebar
  //     },
  //   ],
  // },

  // {
  //   path: '/con', // no url needed as this has submenu
  //   icon: <Cog6ToothIcon className={`${iconClasses} inline`} />, // icon component
  //   name: 'Settings', // name that appear in Sidebar
  //   submenu: [
  //     {
  //       path: '/perfil/admin', // url
  //       icon: <UserIcon className={submenuIconClasses} />, // icon component
  //       name: 'Profile', // name that appear in Sidebar
  //     },
  //   ],
  // },
];

export default routesAdmin;
